// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__MHbvl","containerItemsCenter":"Skeleton_containerItemsCenter__2S6ft"};